import { financialServiceApp } from '../utils/constants/serviceModule';
import { Http } from '../utils/http';

// 支付类型API
export const apiGetPaymentTypeList = () => {
  return Http.Post('/baseDataSupport/mgmt/query-list/get-payment-type-map', {}, financialServiceApp);
};

export const apiGetAllPaymentComponents = () => {
  return Http.Post('/baseDataSupport/mgmt/query-list/get-all-payment-component', {}, financialServiceApp);
};
// 获取所有提现组件
export async function apiGetAllWithdrawComponents() {
  return Http.Post('/baseDataSupport/mgmt/query-list/get-all-withdraw-component', {}, financialServiceApp);
}

// 获取所有提现类型列表
export async function apiGetAllWithdrawTypeList() {
  return Http.Post('/baseDataSupport/mgmt/query-list/get-all-withdraw-type-list', {}, financialServiceApp);
}

// 获取所有货币配置列表
export const apiGetAllCurrencyConfigList = () => {
  return Http.Post('/baseDataSupport/mgmt/query-list/get-all-currency-config-list', {}, financialServiceApp);
};


// 支付渠道API
export const apiGetPaymentChannelList = (params: any) => {
  return Http.Post('/paymentchannel/mgmt/query-list/get-payment-channel-list', params, financialServiceApp);
};

// 支付回调白名单API
export async function apiGetPaymentCallbackWhitelist(params?: any) {
  return Http.Post('/callbackwhitelist/mgmt/query-list/get-call-back-white-list-list', params, financialServiceApp);
}

export async function apiAddPaymentCallbackWhitelist(params: any) {
  return Http.Post('/callbackwhitelist/mgmt/create/create-call-back-white-list', params, financialServiceApp);
}

export async function apiDeletePaymentCallbackWhitelist(params: any) {
  return Http.Post('/callbackwhitelist/mgmt/delete/delete-call-back-white-list', params, financialServiceApp);
}

// 提现方式查询API
export async function apiGetWithdrawalTypeList(params?: any) {
  return Http.Post('/withdrawtype/mgmt/query-list/get-withdraw-type-list', params, financialServiceApp);
}

// 创建提现方式
export async function apiCreateWithdrawType(params: any) {
  return Http.Post('/withdrawtype/mgmt/create/create-withdraw-type', params, financialServiceApp);
}

// 更新提现方式
export async function apiUpdateWithdrawType(params: any) {
  return Http.Post('/withdrawtype/mgmt/update/update-withdraw-type', params, financialServiceApp);
}

// 禁用提现方式
export async function apiFreezeWithdrawType(params: any) {
  return Http.Post('/withdrawtype/mgmt/update/freeze-withdraw-type', params, financialServiceApp);
}

// 启用提现方式
export async function apiUnfreezeWithdrawType(params: any) {
  return Http.Post('/withdrawtype/mgmt/update/unfreeze-withdraw-type', params, financialServiceApp);
}

// 代付渠道设置API
export async function apiGetPaidChannelList(params?: any) {
  return Http.Post('/withdrawchannel/mgmt/query-list/get-withdraw-channel-list', params, financialServiceApp);
}

export async function apiCreatePaidChannel(params: any) {
  return Http.Post('/withdrawchannel/mgmt/create/create-withdraw-channel', params, financialServiceApp);
}

export async function apiUpdatePaidChannel(params: any) {
  return Http.Post('/withdrawchannel/mgmt/update/update-withdraw-channel', params, financialServiceApp);
}

export async function apiUpdateUnfreezeWithdrawChannel(params: any) {
  return Http.Post('/withdrawchannel/mgmt/update/unfreeze-withdraw-channel', params, financialServiceApp);
}

export async function apiUpdateFreezeWithdrawChannel(params: any) {
  return Http.Post('/withdrawchannel/mgmt/update/freeze-withdraw-channel', params, financialServiceApp);
}

export async function apiDeleteWithdrawChannel(params: any) {
  return Http.Post('/withdrawchannel/mgmt/delete/delete-withdraw-channel', params, financialServiceApp);
}

// 删除提现方式
export async function apiDeleteWithdrawType(params: any) {
  return Http.Post('/withdrawtype/mgmt/delete/delete-withdraw-type', params, financialServiceApp);
}

// 支付渠道API
export const apiCreatePaymentChannel = (params: any) => {
  return Http.Post('/paymentchannel/mgmt/create/create-payment-channel', params, financialServiceApp);
};

export const apiUpdatePaymentChannel = (params: any) => {
  return Http.Post('/paymentchannel/mgmt/update/update-payment-channel', params, financialServiceApp);
};

export const apiDeletePaymentChannel = (params: any) => {
  return Http.Post('/paymentchannel/mgmt/delete/delete-payment-channel', params, financialServiceApp);
};

export const apiFreezePaymentChannel = (params: any) => {
  return Http.Post('/paymentchannel/mgmt/update/freeze-payment-channel', params, financialServiceApp);
};

export const apiUnfreezePaymentChannel = (params: any) => {
  return Http.Post('/paymentchannel/mgmt/update/unfreeze-payment-channel', params, financialServiceApp);
};

// 支付类型API
export const apiCreatePaymentType = (params: any) => {
  return Http.Post('/paymenttype/mgmt/create/create-payment-type', params, financialServiceApp);
};

export const apiUpdatePaymentType = (params: any) => {
  return Http.Post('/paymenttype/mgmt/update/update-payment-type', params, financialServiceApp);
};

export const apiDeletePaymentType = (params: any) => {
  return Http.Post('/paymenttype/mgmt/delete/delete-payment-type', params, financialServiceApp);
};

export const apiFreezePaymentType = (params: any) => {
  return Http.Post('/paymenttype/mgmt/update/freeze-payment-type', params, financialServiceApp);
};

export const apiUnfreezePaymentType = (params: any) => {
  return Http.Post('/paymenttype/mgmt/update/unfreeze-payment-type', params, financialServiceApp);
};

export async function apiDeletePaidChannel(params: any) {
  return Http.Post('/withdrawchannel/mgmt/delete/delete-withdraw-channel', params, financialServiceApp);
}

export async function apiGetWithdrawSettingByChannel(params: any) {
  return Http.Post('/withdrawsetting/mgmt/query-list/get-withdraw-setting-by-channel-dataPkCode', params, financialServiceApp);
}

// 订单统计API
export const apiGetPayOrderStat = (params: { curSign: string }) => {
  return Http.Get('/order/stat/pay-order-stat', params, financialServiceApp);
};

export const apiGetPayOrderChannelStat = (params: { curSign: string; paymentChannelId: number }) => {
  return Http.Get('/order/stat/pay-order-channel-stat', { curSign: params.curSign, paymentChannelId: params.paymentChannelId.toString() }, financialServiceApp);
};

export const apiGetWithdrawOrderStat = (params: { curSign: string }) => {
  return Http.Get('/order/stat/withdraw-order-stat', params, financialServiceApp);
};

export const apiGetWithdrawOrderChannelStat = (params: { curSign: string; channelId: number }) => {
  return Http.Get('/order/stat/withdraw-order-channel-stat', { curSign: params.curSign, channelId: params.channelId.toString() }, financialServiceApp);
};

export async function apiCreateWithdrawSetting(params: any) {
  return Http.Post('/withdrawsetting/mgmt/create/create-new-withdraw-setting', params, financialServiceApp);
}

// 获取支付方式列表（带查询条件）
export const apiGetPaymentMethodListWithQuery = (params:any) => {
  return Http.Post('/paymenttype/mgmt/query-list/get-payment-type-list', params, financialServiceApp);
};

// 获取支付渠道参数列表
export const apiGetPaymentChannelParamList = (params: { channelDataPkCode: string }) => {
  return Http.Post('/paymentsetting/mgmt/query-list/get-payment-channel-param-list', params, financialServiceApp);
};

// 创建支付渠道参数
export const apiCreatePaymentChannelParam = (params: {
  channelDataPkCode: string;
  paramJson: string;
}) => {
  return Http.Post('/paymentsetting/mgmt/create/create-payment-channel-param', params, financialServiceApp);
};

// 更新支付渠道状态
export const apiUpdatePaymentChannelStatus = (params: { dataPkCode: string; status: string }) => {
  return Http.Post('/paymentchannel/mgmt/update/update-payment-channel-status', params, financialServiceApp);
};

// 充值订单管理API
export const apiGetRechargeOrderList = (params: any) => {
  return Http.Post('/payorder/mgmt/query-list/get-pay-order-list', params, financialServiceApp);
};

// 确认充值
export const apiConfirmRechargeOrder = (params: any) => {
  return Http.Post('/payorder/mgmt/update/unfreeze-pay-order', {
    dataPkCode: params.dataPkCode,
    status: '70008002'  // 已支付状态
  }, financialServiceApp);
};

// 导出充值订单列表
export const apiExportRechargeOrderList = (params: any) => {
  return Http.Post('/payorder/mgmt/query-list/export-pay-order-list', params, financialServiceApp);
};

/** 向支付渠道查询三方订单状态（公共查单） */
export const apiQueryChannelPayOrder = (params: { dataPkCode?: string; orderNumber?: string }) => {
  return Http.Post('/payorder/mgmt/query/query-channel-pay-order', params, financialServiceApp);
};

export const apiGetRiskWithdrawConfigList = (params: any) => {
  return Http.Post('/riskwithdrawconfig/mgmt/v2/query-list/get-all-risk-withdraw-config-list', params, financialServiceApp);
};

export const apiUpdateRiskWithdrawConfigList = (params: any) => {
  return Http.Post('/riskwithdrawconfig/mgmt/v2/update/update-cursign-risk-withdraw-config-list', params, financialServiceApp);
};




